import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Pokemon from '@/components/Pokemon'

Vue.use(Router, VueAxios, axios)
Vue.prototype.$http = axios

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Pokemon',
      component: Pokemon
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js